import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _AVATAR_ICON_SIZES, _AVATAR_WRAPPER_SIZES;

export var AVATAR_COLORS = {
  COLOR_100: '100',
  COLOR_200: '200',
  COLOR_300: '300',
  COLOR_400: '400',
  COLOR_500: '500',
  COLOR_600: '600',
  COLOR_700: '700',
  COLOR_800: '800'
};
export var AVATAR_SIZES = {
  RESPONSIVE: 'responsive',
  SMALL: 'small',
  STANDARD: 'standard'
};
export var AVATAR_ICON_SIZES = (_AVATAR_ICON_SIZES = {}, _defineProperty(_AVATAR_ICON_SIZES, AVATAR_SIZES.RESPONSIVE, '20px'), _defineProperty(_AVATAR_ICON_SIZES, AVATAR_SIZES.SMALL, '20px'), _defineProperty(_AVATAR_ICON_SIZES, AVATAR_SIZES.STANDARD, '24px'), _AVATAR_ICON_SIZES);
export var AVATAR_WRAPPER_SIZES = (_AVATAR_WRAPPER_SIZES = {}, _defineProperty(_AVATAR_WRAPPER_SIZES, AVATAR_SIZES.RESPONSIVE, '32px'), _defineProperty(_AVATAR_WRAPPER_SIZES, AVATAR_SIZES.SMALL, '32px'), _defineProperty(_AVATAR_WRAPPER_SIZES, AVATAR_SIZES.STANDARD, '40px'), _AVATAR_WRAPPER_SIZES);
export var AVATAR_VARIANTS = {
  EMPTY: 'empty',
  ICON: 'icon',
  IMAGE: 'image',
  TEXT: 'text'
};